<div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <h1 class="!mb-0 !leading-[1.2] !text-3xl md:!text-5xl lg:!text-[50px] xl:!text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]">
            <!--i18n - Cookie management policy -->
            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_page' | translate }}
        </h1>
        <div class="absolute bottom-0 -z-[1] ltr:-right-[30px] rtl:-left-[30px] blur-[250px]">
            <img src="images/front-pages/shape3.png" alt="shape3">
        </div>
        <div class="absolute -top-[220px] -z-[1] ltr:-left-[50px] rtl:-right-[50px] blur-[150px]">
            <img src="images/front-pages/shape5.png" alt="shape3">
        </div>
    </div>
</div>

<div class="pb-[60px] md:pb-[80px] lg:pb-[100px] xl:pb-[150px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <div class="grid grid-cols-1  gap-[25px] items-center">
            <div>
                <ul class="ltr:xl:pl-[18px] rtl:xl:pr-[18px] mt-[25px] md:mt-[30px] lg:mt-[35px] xl:mt-[65px]">
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[2px] xl:mb-[5px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            globe
                        </i>
                        <div class="grid grid-cols-[auto_1fr] gap-5">
                            <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                                <!--i18n - Website concerned: -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_title_01' | translate }}
                            </h3>
                            <div class="!leading-[1.6]  text-gray-500">
                                <!--i18n - www. xxxx.fr -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_p_01' | translate }}
                            </div>
                            
                        </div>
                    </li>
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[2px] xl:mb-[5px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            enterprise
                        </i>
                        <div class="grid grid-cols-[auto_1fr] gap-5">
                            <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                                <!--i18n - Responsible company: -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_title_02' | translate }}
                            </h3>
                            <div class="!leading-[1.6]  text-gray-500">
                                <!--i18n - LOOMIS FXGS -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_p_02' | translate }}
                            </div>
                        </div>
                    </li>
                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            alarm
                        </i>
                        <div class="grid grid-cols-[auto_1fr] gap-5">
                            <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                                <!--i18n - Last updated: -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_title_03' | translate }}
                            </h3>
                            <div class="!leading-[1.6]  text-gray-500">
                                <!--i18n - '27/04/2026 -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.sub_p_03' | translate }}
                            </div>
                        </div>
                    </li>
                    <br>


                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - What is a cookie? -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_01' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -A cookie is a small text file placed on your device (computer, tablet,... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_01_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Cookies are managed by your web browser. We encourage you to read this... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_01_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n - Who is responsible for the processing? -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_02' | translate }}
                        </h3>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -The data controller for the data collected via cookies is: -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_02_01' | translate }}
                        </p>

                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -LOOMIS FXGS - 79, rue Benoit MALON - 94250 Gentilly - FRANCE  -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_02_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[15px] md:!text-md lg:!text-[17px] xl:!text-lg !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -What are the different types of cookies and which ones are used on the Site? -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_03' | translate }}
                        </h3>
                        
                        <h4 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--Strictly necessary cookies (exempt from consent) -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_03_01' | translate }}
                        </h4>

                        <p class="!leading-[1.6] text-gray-500">
                           <!--i18n -These cookies are essential for the Site to function. They cannot be disable... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_01_01' | translate }}
                        </p>
                    
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Managing your login session (secure authentication)... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_03_01_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Remembering your browsing preferences during your session... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_03_01_02' | translate }}
                        </p>

                        <div class="grid grid-cols-3 p-5 text-gray-500">
                            <div class="border border-gray-300">
                                <!--i18n -Cookie name -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_01' | translate }}
                            </div>
                            <div class="border border-gray-300">
                                <!--i18n -Purpose -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_02' | translate }}
                            </div>
                            <div class="border border-gray-300">
                                <!--i18n -Shelf life -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_03' | translate }}
                            </div>

                            <div class="border border-gray-300">
                                <!--i18n -AspNetCore.Cookies -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_04' | translate }}
                            </div>
                            <div class="border border-gray-300">
                                <!--i18n -Maintaining the user session -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_05' | translate }}
                            </div>
                            <div class="border border-gray-300">
                                <!--i18n -Session duration -->
                                {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.grid_cell_03_02_06' | translate }}
                            </div>
                        </div>
                        <br>
                        
                        <h4 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--Analytical and audience measurement cookies (subject to consent)... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_03_02' | translate }}
                        </h4>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -These cookies allow us to measure our website's audience and analyze user... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_02_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -These cookies can only be placed after obtaining your consent.... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_02_02' | translate }}
                        </p>

                        <h4 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Performance and functional cookies (subject to consent) -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_03_03' | translate }}
                        </h4>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -These cookies allow us to improve your experience on the site by... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_03_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -These cookies can only be placed after obtaining your consent. Loomis .... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_03_02' | translate }}
                        </p>

                        <h4 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Third-party cookies (subject to consent) -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_03_04' | translate }}
                        </h4>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Third-party services that may place their own cookies.... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_04_01' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -These cookies can only be placed after obtaining your consent. Loomis FXGS .... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_03_04_02' | translate }}
                        </p>        
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -How do I manage my cookies? -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_04' | translate }}
                        </h3>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -You can configure your browser to accept or reject cookies. Each browser -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_04_01' | translate }}
                        </p>

                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Google Chrome: Menu > Settings > Privacy and security > Cookie... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_04_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Mozilla Firefox: Menu > Options > Privacy and Security > Cookies... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_04_02' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Safari: Preferences > Privacy > Cookies and website data... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_04_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Microsoft Edge: Menu > Settings > Privacy, search and services > Cookies... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_04_04' | translate }}
                        </p>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Warning: Disabling certain cookies may impair the proper functioning o -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_04_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Shelf life -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_05' | translate }}
                        </h3>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Cookies are stored for varying periods depending on their purpose... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_05_01' | translate }}
                        </p>

                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Session cookies: deleted when the browser is clo... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_05_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Persistent cookies: stored for the duration indicated in the tables above,... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_05_02' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Your rights -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_06' | translate }}
                        </h3>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -You can exercise these rights by contacting the Data Protection Offic... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_06_01' | translate }}
                        </p>

                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -By email to the following address: dpo@fr.loomis.com... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_06_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -By mail to the following address: DPO Department – ​​Loomis FXGS – ... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_06_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Your application must include your full name, email or postal addres... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_06_02' | translate }}
                        </p>
                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -If, after contacting our DPO, you believe that your rights have not been... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_06_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -Available online at www.cnil.fr ... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_06_03' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -By mail to the following address: CNIL – 3, place de Fontenoy – TSA 807 ... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_06_04' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Policy changes -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_07' | translate }}
                        </h3>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -Loomis FXGS reserves the right to modify this policy at any time, particul... -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_07_01' | translate }}
                        </p>
                    </li>

                    <li class="relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[28px] rtl:md:pr-[28px] ltr:lg:pl-[30px] rtl:lg:pr-[30px] mb-[25px] xl:mb-[32px] last:mb-0">
                        <i class="material-symbols-outlined absolute text-primary-600 !text-[17px] md:!text-lg lg:!text-[20px] ltr:left-0 rtl:right-0 top-0 leading-none">
                            lightbulb
                        </i>
                        <h3 class="!text-[9px] md:![11px] lg:!text-[13px] xl:!text-[15px] !mb-[8px] md:!mb-[10px] !font-semibold !leading-[1.2]">
                            <!--i18n -Contact -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.title_08' | translate }}
                        </h3>

                        <p class="!leading-[1.6]  text-gray-500">
                            <!--i18n -For any questions relating to this policy or the use of cookies on our .. -->
                            {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.p_08_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -By email to the following address: dpo@fr.loomis.com ... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_08_01' | translate }}
                        </p>
                        <p class="flex items-center gap-1 text-gray-500 !mb-1">
                            <span class="material-symbols-outlined lg:!text-[17px] xl:!text-lg align-middle text-green-500">
                                target
                            </span>
                            <!--i18n -By mail to the following address: DPO Department – ​​Loomis FXGS – 79, rue ... -->
                           {{ 'i18n.app.features.pages.front-pages.legal.cookie-management-policy.bp_08_02' | translate }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <!-- shape :  Tache floue bas droite -->
        <div class="absolute -z-[1] ltr:-right-[30px] rtl:-left-[30px] bottom-[50px] blur-[150px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[380px] h-[380px]">
        </div>

        <!-- shape : Tache floue haut (remplace shape8) -->
        <div class="absolute -z-[1] ltr:left-[250px] rtl:left-[260px] top-[265px] blur-[175px]
                   bg-secondary-400/[0.25] dark:bg-primary-100/[0.25] rounded-full
                   w-[420px] h-[340px]">
        </div>


        <div class="absolute -top-[60px] ltr:left-[65px] rtl:right-[65px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <div class="absolute -bottom-[30px] ltr:right-[20px] rtl:left-[20px] -z-[1] blur-[125px]">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div>
    </div>
</div>